import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AppPlaceholdersArray, getTranslationKeyForAppPlaceholder, isAppPlaceholderPattern} from '@shared-types';

type PlaceholderMapPipeOptions = Partial<{
	showTranslation?: boolean; // default: false -> show the placeholder
}>;

@Pipe({
	name: 'placeholderMap',
	standalone: true,
})
export class PlaceholderMapPipe implements PipeTransform {
	private readonly translationService: TranslateService = inject(TranslateService);
	private static readonly AppPlaceholdersArray = AppPlaceholdersArray;

	transform(value: string, options?: PlaceholderMapPipeOptions): string {
		if (isAppPlaceholderPattern(value)) {
			const matchedPlaceholder = PlaceholderMapPipe.AppPlaceholdersArray.find(p => value.includes(p));
			if (matchedPlaceholder) {
				if (options?.showTranslation) {
					let phTranslation = getTranslationKeyForAppPlaceholder(matchedPlaceholder);
					if (phTranslation) {
						phTranslation = this.translationService.instant(phTranslation);
					}
					return value.replace(matchedPlaceholder, phTranslation);
				} else {
					return matchedPlaceholder;
				}
			}
		}
		return value;
	}
}
